import { render, staticRenderFns } from "./ConsumerProfil.vue?vue&type=template&id=22c32884&scoped=true"
import script from "./ConsumerProfil.vue?vue&type=script&lang=js"
export * from "./ConsumerProfil.vue?vue&type=script&lang=js"
import style0 from "./ConsumerProfil.vue?vue&type=style&index=0&id=22c32884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c32884",
  null
  
)

export default component.exports